import { BrowserDomGateway } from '@mojility/core-es6';

export default {
  name: 'browserDomGateway',
  fn: BrowserDomGateway
}